export const LANGUAGE_DROPDOWN_CONTENT = 'LANGUAGE_DROPDOWN_CONTENT'
